import apiClient from '../client';

export interface ContactSubmitData {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  message?: string;
  source?: string;
}

export interface NewsletterData {
  firstName: string;
  lastName: string;
  email: string;
}

export interface ContactSubmission {
  id: number;
  name: string;
  email: string;
  phone?: string;
  company?: string;
  message?: string;
  source: string;
  status: string;
  createDate: string;
}

export const contactApi = {
  submit: (data: ContactSubmitData) => apiClient.post('/contact/submit', data),

  newsletter: (data: NewsletterData) => apiClient.post('/contact/newsletter', data),
};
